"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var lion_head_symbol_svg_1 = __importDefault(require("@assets/components/app/base-layout/lion-head-symbol.svg"));
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        masthead: {
            zIndex: 2,
            position: function (props) {
                return props.isSticky && props.toStick ? 'absolute' : 'relative';
            },
            backgroundColor: '#F0F0F0',
            height: 'auto',
            padding: '4px 0',
            fontSize: '14px',
        },
        mastheadLink: {
            marginLeft: '30px',
            fontFamily: 'lato',
            color: '#484848',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
                color: '#151515',
            },
        },
        mastheadText: {
            marginLeft: '4px',
        },
    });
});
var Masthead = function (_a) {
    var isSticky = _a.isSticky, toStick = _a.toStick;
    var classes = useStyles({ isSticky: isSticky, toStick: toStick });
    return (react_1.default.createElement("div", { className: classes.masthead },
        react_1.default.createElement("a", { href: "https://www.gov.sg", target: "_blank", rel: "noopener noreferrer", className: classes.mastheadLink },
            react_1.default.createElement("img", { src: lion_head_symbol_svg_1.default, alt: "" }),
            react_1.default.createElement("span", { className: classes.mastheadText }, "Un site de beta.gouv.fr"))));
};
exports.default = Masthead;
